module.exports = __webpack_public_path__ + "img/p-two-step-08.d83b8202.png";